var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFileDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_16580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 15.75V17.25C20 18.49 18.99 19.5 17.75 19.5H7.25C6.01 19.5 5 18.49 5 17.25V15.75C5 15.34 4.66 15 4.25 15C3.84 15 3.5 15.34 3.5 15.75V17.25C3.5 19.32 5.18 21 7.25 21H17.75C19.82 21 21.5 19.32 21.5 17.25V15.75C21.5 15.34 21.16 15 20.75 15C20.34 15 20 15.34 20 15.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7497 3.75L11.7697 15.58C11.6497 15.51 11.5397 15.43 11.4397 15.34L8.52967 12.43C8.23967 12.13 7.76967 12.12 7.46967 12.41C7.16967 12.7 7.15967 13.17 7.44967 13.47C7.44967 13.47 7.45967 13.48 7.46967 13.49L10.3797 16.4C11.5497 17.57 13.4497 17.57 14.6197 16.4L17.5297 13.49C17.8297 13.2 17.8397 12.73 17.5497 12.43C17.2597 12.13 16.7897 12.12 16.4897 12.41C16.4897 12.41 16.4797 12.42 16.4697 12.43L13.5597 15.34C13.4697 15.42 13.3797 15.5 13.2697 15.56L13.2497 3.75C13.2497 3.34 12.9097 3 12.4997 3C12.0897 3 11.7497 3.34 11.7497 3.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_16580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3.5 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFileDown);
export default __webpack_public_path__ + "static/media/ico-file-down.170527fcf2affe5a8e04006e525f0e95.svg";
export { ForwardRef as ReactComponent };